export default {
    account: {
        singular: 'compte',
    },
    divisions: {
        general: 'général',
    },
    civility: {
        singular: 'civilité',
    },
    loyalty: {
        singular: 'loyauté',
    },
    delivery: {
        singular: 'livraison',
        plural: 'livraisons',
    },
    deliverable: {
        singular: 'livrable',
    },
    delivered: {
        infinitive: 'livrer',
        singular: 'livré',
        plural: 'livrés',
        feminineSingular: 'livrée',
        femininePlural: 'livrées',
    },
    deliveryDate: {
        singular: 'à livrer le',
    },
    dashboard_columns: {
        presented: 'visite',
    },
    presented: {
        singular: 'visite',
    },
    presentedOther: {
        singular: 'autre visite',
    },
    province: {
        CA: 'province',
    },
    portfolio: {
        singular: 'renouvellement',
        plural: 'renouvellements',
        prefix: 'le renouvellement',
        abr: 'renouv.',
    },
    renewal: {
        singular: 'renouvellement',
        plural: 'renouvellements',
    },
    renewed: {
        infinitive: 'renouveler',
        singular: 'renouvelé',
        plural: 'renouvelés',
    },
    result: {
        singular: 'résultat',
    },
    sale: {
        singular: 'vente',
        plural: 'ventes',
        prefix: 'une vente',
    },
    secondaryAdvisor: {
        singular: 'second conseiller',
    },
    sold: {
        singular: 'vendu',
        plural: 'vendus',
    },
    undelivered: {
        singular: 'non livré',
        plural: 'non livrés',
    },
    version: {
        singular: 'version',
    },
    walkIn: {
        singular: 'walk-in',
        plural: 'walk-in',
        prefix: 'a walk-in',
        abr: 'walk-in',
    },
    certified: 'Certifié',
};
